import './App.css';
import { CountdownTimer } from './Component/CountdownTimer';
import SVOLogo from "./assets/images/svo-logo.png";
import ETH_logo from "./assets/images/eth-logo.png";
import USDCLogo from "./assets/images/usdc-logo.png";
import USDTLogo from "./assets/images/usdt-logo.png";
import DollarLogo from "./assets/images/dollar.png";

import { debounce } from "lodash";


// import Slider from 'rc-slider';
import { useEffect, useState } from 'react';
// import * as Slider from "@radix-ui/react-slider";
import "@radix-ui/themes/styles.css";
import { Slider } from "radix-ui";
import { useAccount, useBalance, useNetwork, useSwitchNetwork } from "wagmi";
import { useWeb3Modal } from "@web3modal/wagmi/react";
import toast, { Toaster } from 'react-hot-toast';
import Web3 from 'web3';
import emailjs from "@emailjs/browser";
import Countdown from "react-countdown";

import {
  prepareWriteContract,
  waitForTransaction,
  writeContract,
} from "@wagmi/core";
import {
  preSale_Contract_ABI,
  preSale_Contract_Address,
  USDC_Contract_Abi,
  USDC_Contract_Address,
  USDT_Contract_Abi,
  USDT_Contract_Address,
  TOKEN_Contract_Address,
  TOKEN_Contract_Abi
} from "./utilies/constant";




const Completionist = () => {
  // window.location.reload();
  return <></>;
};

const renderer = ({ days, hours, minutes, seconds, completed }) => {
  // console.log("renderer",items);
  if (completed) {
    return <Completionist />;
  } else {
    return (
      <div  className="flex justify-between items-center gap-4 text-[56px] font-semibold">
        <div className="">
          <div>
            <h1 className="flex flex-col gap-1">{days}</h1>
            <p className="text-base text-opacity-80">DAYS</p>
          </div>
        </div>
        {/* <div className="col-3"> */}
          <div>
            <h1 className="flex flex-col gap-1">{hours}</h1>
            <p className="text-base text-opacity-80">HOURS</p>
          </div>
        {/* </div> */}
        {/* <div className="col-3"> */}
          <div>
            <h1 className="flex flex-col gap-1">{minutes}</h1>
            <p className="text-base text-opacity-80">Minutes</p>
          </div>
        {/* </div> */}
        {/* <div className="col-3"> */}
          <div>
            <h1 className="flex flex-col gap-1">{seconds}</h1>
            <p className="text-base text-opacity-80">Seconds</p>
          </div>
        </div>
      // </div>
    );
  }
};








function App() {
  const webSupply = new Web3("https://ethereum-rpc.publicnode.com");
  const [selectedType, setSelectedType] = useState({ name: "ETH", img: ETH_logo });
  const [showModal, setShowModal] = useState(false);
  const { chain } = useNetwork();
  const { chains, switchNetwork } = useSwitchNetwork();
  const { address } = useAccount();
  const { open } = useWeb3Modal();
  const [getBalances, setgetBalances] = useState(0);
  const [getETH_value, setgetETH_value] = useState("");
  const [spinner, setspinner] = useState(false);
  const [showToken, setshowToken] = useState(0);
  const [isclaim, setisclaimopen] = useState("");
  const [usdtraised, setusdtraised] = useState(0);
  const [tokenSoldValue, setTokenSoldValue] = useState(0)
  const [tokenBalance, setTokenBalance] = useState(0)
  const [salePrice, setsalePrice] = useState(0)

  const [balanceSpinner, setBalanceSpinner] = useState(false)

  const { data, isError, isLoading } = useBalance({
    address,
  });
  let history = window.location;

  const handleChange_value = (e) => {
    setgetETH_value(e.target.value);
  };



  const contractData = debounce(async () => {
    try {

      const contract = new webSupply.eth.Contract(preSale_Contract_ABI, preSale_Contract_Address);
      const contractOfToken = new webSupply.eth.Contract(TOKEN_Contract_Abi, TOKEN_Contract_Address);
  
    
      const [totalUSDTRaised, tokenSold, TokenpricePerUsdt] = await Promise.all([
        contract.methods.totalUSDTRaised().call(),
        contract.methods.TokenSold().call(),
        contract.methods.TokenPricePerUsdt().call(),
      ]);
  
     
      const tokenSoldValue = parseFloat(webSupply.utils.fromWei(tokenSold.toString())) + 1274444 ;
  
      
      setTokenSoldValue(tokenSoldValue.toFixed(0)); 
  
      if (address) {
        const tokenBalanceOf = await contractOfToken.methods.balanceOf(address).call();
        setTokenBalance(webSupply.utils.fromWei(tokenBalanceOf.toString()));
      }
  

      setusdtraised(((totalUSDTRaised / 1000000) + 183493.60).toString());
  

      setsalePrice(Number(1) / Number(webSupply.utils.fromWei(TokenpricePerUsdt.toString())));
  
    } catch (error) {
      console.error("Error fetching contract data:", error);
    }
  }, 500); 






  const balanceOf = async () => {
    try {
      if (!address) return;
      setBalanceSpinner(true)
      const contract = new webSupply.eth.Contract(preSale_Contract_ABI, preSale_Contract_Address);
      const tokenContractUSDT = new webSupply.eth.Contract(USDT_Contract_Abi, USDT_Contract_Address);
      const tokenContractUSDC = new webSupply.eth.Contract(USDC_Contract_Abi, USDC_Contract_Address);
      let balanceUSDC = await tokenContractUSDC.methods.balanceOf(address).call()
      let balanceUSDT = await tokenContractUSDT.methods.balanceOf(address).call()
      let bnbBalance = await webSupply.eth.getBalance(address)

      let balance = 0;
      if (selectedType?.name === "ETH") {
        balance = data?.formatted.toString()
      } else if (selectedType?.name === "USDT") {
        balance = Number(balanceUSDT) / Number(1000000)
      } else if (selectedType?.name === "USDC") {
        balance = Number(balanceUSDC) / Number(1000000)
      }

      setgetBalances(balance.toString())
      setBalanceSpinner(false)


      const [totalUSDTRa, isClaimOpen, usdcBalance, usdtBalance] = await Promise.all([
        // contract.methods.totalUSDTRaised().call(),
        contract.methods.Claimable(address).call(),
        tokenContractUSDC.methods.balanceOf(address).call(),
        tokenContractUSDT.methods.balanceOf(address).call()
      ]);

      setisclaimopen(isClaimOpen);


      ;
    } catch (error) {
      setBalanceSpinner(false)

      console.error("Error fetching balance:", error);
    }
  };




  const getTokenValue = debounce(async () => {
    try {
      if (!getETH_value || Number(getETH_value) <= 0) return;
  
      const contract = new webSupply.eth.Contract(
        preSale_Contract_ABI,
        preSale_Contract_Address
      );
  
      const valueETH = webSupply.utils.toWei(getETH_value.toString());
  
      if (!selectedType?.name) return;
  
      let tokenValue;
  
      if (selectedType.name === "ETH") {
        try {
          tokenValue = await contract.methods.ETHToToken(valueETH).call();
        } catch (err) {
          console.error("ETH conversion error:", err);
        }
      } else if (["USDT", "USDC"].includes(selectedType.name)) {
        try {
          tokenValue = await contract.methods.getValuePerUsdt(getETH_value * 1000000).call();
        } catch (err) {
          console.error("USDT/USDC conversion error:", err);
        }
      }
  
      if (tokenValue !== undefined) {
        setshowToken(
          selectedType.name === "ETH"
            ? webSupply.utils.fromWei(tokenValue.toString())
            : (Number(tokenValue) / 1000000).toString()
        );
      }
    } catch (error) {
      console.error("Error fetching token value:", error);
    }
  }, 500); // Debounce for 500ms delay



  // USDT FUNCTION WHEN ALREADY APPROVED

  const Buy_Token = async () => {
    try {
      if (!getETH_value) {
        toast.error("Please Enter Amount First!");
        setspinner(false);
        return;
      }
  
      if (!address) {
        toast.error("Please Connect Metamask First!");
        return;
      }
  
      const isETH = selectedType?.name === "ETH";
      const isUSDT = selectedType?.name === "USDT";
      const isUSDC = selectedType?.name === "USDC";
  
      let balanceCheck;
      if (isETH) {
        balanceCheck = Number(data?.formatted || 0); // ETH balance from wagmi
      } else {
        // Fetch USDT/USDC balance directly from the contract
        const contractAddress = isUSDT ? USDT_Contract_Address : USDC_Contract_Address;
        const contractABI = isUSDT ? USDT_Contract_Abi : USDC_Contract_Abi;
        const tokenContract = new webSupply.eth.Contract(contractABI, contractAddress);
        const rawBalance = await tokenContract.methods.balanceOf(address).call();
        balanceCheck = Number(webSupply.utils.fromWei(rawBalance, "mwei")); // 6 decimals
      }
  
      if (Number(getETH_value) > balanceCheck) {
        toast.error(`Insufficient ${selectedType?.name} Balance: ${balanceCheck}`);
        setspinner(false);
        return;
      }
  
      const referralAddress =
        new URLSearchParams(window.location.search).get("ref") ||
        "0x0000000000000000000000000000000000000000";
  
      setspinner(true);
  
      if (isETH) {
        const stakingValue = webSupply.utils.toWei(getETH_value.toString());
  
        const { request } = await prepareWriteContract({
          address: preSale_Contract_Address,
          abi: preSale_Contract_ABI,
          functionName: "BuyWithETH",
          args: [],
          value: stakingValue.toString(),
          account: address,
        });
  
        const { hash } = await writeContract(request);
        await waitForTransaction({ hash });
        setspinner(false);
        toast.success("Purchase Successful");
      } else if (isUSDT || isUSDC) {
        const stakingValue = Number(getETH_value) * 1_000_000; // 6 decimals for USDT/USDC
  
        const contractAddress = isUSDT ? USDT_Contract_Address : USDC_Contract_Address;
        const contractABI = isUSDT ? USDT_Contract_Abi : USDC_Contract_Abi;
        const functionName = isUSDT ? "BuyTokenWithUSDT" : "BuyTokenWithUSDC";
  
        const tokenContract = new webSupply.eth.Contract(contractABI, contractAddress);
        const currentAllowance = await tokenContract.methods
          .allowance(address, preSale_Contract_Address)
          .call();
  
        // Optimize approval: reset only if necessary and insufficient
        if (isUSDT && Number(currentAllowance) > 0 && Number(currentAllowance) < stakingValue) {
          const { request: resetRequest } = await prepareWriteContract({
            address: contractAddress,
            abi: contractABI,
            functionName: "approve",
            args: [preSale_Contract_Address, "0"],
            account: address,
          });
  
          const { hash: resetHash } = await writeContract(resetRequest);
          await waitForTransaction({ hash: resetHash });
          toast.success("Allowance Reset Successful");
        }
  
        // Approve only if current allowance is insufficient
        if (Number(currentAllowance) < stakingValue) {
          const { request: approveRequest } = await prepareWriteContract({
            address: contractAddress,
            abi: contractABI,
            functionName: "approve",
            args: [preSale_Contract_Address, stakingValue.toString()],
            account: address,
          });
  
          const { hash: approveHash } = await writeContract(approveRequest);
          await waitForTransaction({ hash: approveHash });
          toast.success("Approve Successful");
        } else {
          // toast.success("Using Existing Approval");
        }
  
        // Purchase after approval
        await new Promise(resolve => setTimeout(resolve, 3000)); // Cleaner timeout
        const { request: purchaseRequest } = await prepareWriteContract({
          address: preSale_Contract_Address,
          abi: preSale_Contract_ABI,
          functionName,
          args: [stakingValue.toString()],
          account: address,
        });
  
        const { hash: purchaseHash } = await writeContract(purchaseRequest);
        await waitForTransaction({ hash: purchaseHash });
  
        toast.success("Purchase Successful");
        setspinner(false);
      }
    } catch (error) {
      console.error("Error", error.message);
      toast.error("Transaction Failed");
      setspinner(false);
    }
  };




  useEffect(() => {
    getTokenValue()
  }, [getETH_value, address, selectedType]);

  useEffect(() => {
    balanceOf()
  }, [address, selectedType]);

  useEffect(() => {
      contractData();
  }, [address]);


  const sendEmail = (e) => {
    e.preventDefault(); 
    const form = e.target;
    setspinner(true);
    emailjs
      .sendForm("service_38oqm4q", "template_dgdv6eh", form, {
        publicKey: "AXCnyKEvaBPI6MKoE",
      })

     
      .then(
        () => {
          setShowModal(false)
          form.reset();
          setspinner(false);

        },
        (error) => {
          setspinner(false);

          console.log("FAILED...", error);
        }
      );
  };


  return (
    <>
      <Toaster />

      <div className='px-[15px]' >
        {/* max-w-[1200px] */}
        <div className=" mx-auto py-[5vh] text-white leading-none text-base text-center">
          <div className="max-w-[500px] mx-auto text-center">
            <h2 className='font-semibold text-[34px] mb-8'>Next 10% price increase in</h2>
            <Countdown
                      date={parseInt("1747944000") * 1000}
                      renderer={renderer}
                    />
            {/* <CountdownTimer targetDate="2025-05-23T12:00:00" /> */}
          </div>
          <div className='flex justify-between'>
            <div className='flex flex-col items-start p-6 gap-2'>
              <span className='text-[#C9BEBE]'>USDT Raised</span>
              <span className='text-xl font-semibold'>
                ${new Intl.NumberFormat('en-US', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }).format(parseFloat(usdtraised))}
              </span>
            </div>
            {/* <div className='flex flex-col items-end p-6 gap-2'>
              <span className='text-[#C9BEBE]'>Holdings</span>
              <span className='text-xl font-semibold'>{parseFloat(tokenBalance).toFixed(3)} SVO</span>
            </div> */}
              <div className='flex flex-col items-end p-6 gap-2'>
              <span className='text-[#C9BEBE]'>SVO Launch Date</span>
              <span className='text-xl font-semibold'>27 May 2025</span>
            </div>
          </div>
          {/* backdrop-blur-sm bg-[#141617]/60 */   }
          <div className=''>
            <div className='px-[15px] lg:px-[80px] pt-[15px] lg:pt-[56px] mb-[50px]'>
              <div className="flex justify-between items-center font-semibold mb-9 flex-col md:flex-row">
                <div className='flex items-center gap-2'>
                  <img src={SVOLogo} alt="" />
                  <span> 1 SVO </span>
                  <span>=</span>
                  <img src={DollarLogo} alt="" />
                  <span>{parseFloat(salePrice).toFixed(4)}</span>
                </div>
                <span className="font-normal">Remaining SVO available at current price: {(4006876 - parseFloat(tokenSoldValue)).toLocaleString()}</span>

              </div>
              <div className='mb-[50px] lg:mb-[150px]'>
                {/* <Slider
                  defaultValue={30}
                  railStyle={{ backgroundColor: '#342D3A', height: 24, borderRadius: 30 }}
                  trackStyle={{ height: 24, borderRadius: 30 }}
                  handleStyle={{
                    height: 40,
                    width: 40,
                    marginLeft: -10,
                    marginTop: -10,
                    backgroundColor: 'white',
                    opacity: 1
                  }}
                /> */}
                <Slider.Root
                  className="relative flex h-6 w-full touch-none select-none items-center"
                  defaultValue={[((Number(usdtraised)) / Number(100)) * 100]}
                  value={[((Number(usdtraised)) / Number(40000000 )) * 100]}
                  max={100}
                  step={1}
                  disabled={true}
                >
                  <Slider.Track className="relative h-6 grow rounded-full bg-[#342D3A]">
                    <Slider.Range className="absolute h-full rounded-full bg-gradient-to-r from-white to-[#32CF0F]" />
                  </Slider.Track>
                  <Slider.Thumb
                    className="relative block size-10 rounded-full bg-white hover:bg-violet3 focus:shadow-[0_0_0_5px] focus:shadow-blackA5 focus:outline-none"
                    aria-label="Volume"
                  >
                    <div className='absolute top-[60px] left-1/2 transform -translate-x-1/2'>
                      <div className='px-4 py-3 w-[180px] bg-white text-black font-semibold leading-normal relative'>
                        <div className='size-5 rounded-full absolute top-0 left-1/2 bg-white -translate-x-1/2 -translate-y-1/2'></div>
                        <div className='h-6 w-0.5 rounded-full absolute top-0 left-1/2 bg-white -translate-x-1/2 -translate-y-full'></div>
                        <span> {Intl.NumberFormat().format(parseFloat(tokenSoldValue).toFixed(0))} <br /> SVO Sold</span>
                      </div>
                    </div>
                  </Slider.Thumb>
                </Slider.Root>
              </div>
            </div>
            <div className='mb-[60px] lg:mb-[130px]'>
              <h5 className='text-xl text-[#C9BEBE] mb-8'><span className='text-white font-semibold'>Step 1</span> - Select the payment method</h5>
              <div className='text-xl text-start flex md:flex-row flex-col'>
                <div
                  className={`${selectedType.name === "ETH" ? "border-gray-500" : "border-[#312C35]"} border w-full flex items-center justify-between px-6 py-4 cursor-pointer`}
                  onClick={() => {setSelectedType({ name: "ETH", img: ETH_logo });setgetETH_value("")}}
                >
                  <div className='flex items-center gap-4 flex-shrink-0'>
                    <img src={ETH_logo} width={48} height={48} alt="" />
                    <div className='flex flex-col'>
                      <span>ETH</span>
                      <span className='text-base text-[#C9BEBE]'>ERC  - 20</span>
                    </div>
                  </div>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6 9L12 15L18 9" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </div>
                <div
                  className={`${selectedType.name === "USDT" ? "border-gray-500" : "border-[#312C35]"} border w-full flex items-center justify-between px-6 py-4 cursor-pointer`}
                  onClick={() => {setSelectedType({ name: "USDT", img: USDTLogo });setgetETH_value("")}}
                >
                  <div className='flex items-center gap-4 flex-shrink-0'>
                    <img src={USDTLogo} width={48} height={48} alt="" />
                    <div className='flex flex-col'>
                      <span>USDT</span>
                      <span className='text-base text-[#C9BEBE]'>ERC  - 20</span>
                    </div>
                  </div>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6 9L12 15L18 9" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </div>
                <div
                  className={`${selectedType.name === "USDC" ? "border-gray-500" : "border-[#312C35]"} border w-full flex items-center justify-between px-6 py-4 cursor-pointer`}
                  onClick={() => {setSelectedType({ name: "USDC", img: USDCLogo });setgetETH_value("")}}
                >
                  <div className='flex items-center gap-4 flex-shrink-0'>
                    <img src={USDCLogo} width={48} height={48} alt="" />
                    <div className='flex flex-col'>
                      <span>USDC</span>
                      <span className='text-base text-[#C9BEBE]'>ERC  - 20</span>
                    </div>
                  </div>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6 9L12 15L18 9" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </div>
              </div>
            </div>

            <div className="max-w-[600px] mx-auto text-center">
              <div className='mb-10'>
                <h5 className='text-xl text-[#C9BEBE] mb-8'><span className='text-white font-semibold'>Step 2</span> - Enter the amount of token you would like to purchase</h5>

                <h5 className='text-xl text-[#C9BEBE] mb-8'><span className='text-white font-semibold'>Balance of {selectedType.name} :  {balanceSpinner ? "Loading..." : parseFloat(getBalances).toFixed(3)}</span></h5>
                <div className='border border-[#312C35] p-6 text-xl text-start flex flex-col md:flex-row'>

                  <div className='md:w-1/2 flex items-center md:pr-6 md:pb-0 pb-6'>
                    <input type="number" className='bg-transparent w-full placeholder-white'
                      value={getETH_value}
                      placeholder='0'
                      onChange={handleChange_value}
                    />
                    <div className='flex items-center gap-2 flex-shrink-0'>

                      <span>{selectedType.name}</span>
                      <img src={selectedType.img} width={32} height={32} alt={selectedType.name} />
                    </div>
                  </div>
                  <div className='md:w-1/2 flex items-center md:pl-6 relative md:pt-0 pt-6'>
                    <span className='absolute text-4xl font-semibold md:left-0 left-1/2 top-0 md:top-1/2 transform -translate-x-1/2 -translate-y-1/2'>=</span>
                    <span className='w-full'>{parseFloat(showToken).toFixed(2)}</span>
                    <div className='flex items-center gap-2 flex-shrink-0'>
                      <span>SVO</span>
                      <img src={SVOLogo} width={32} height={32} alt="" />
                    </div>
                  </div>
                </div>
              </div>
              {/* <button className='font-semibold inline-flex items-center gap-2'>
                <span>How to buy</span>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.83203 14.1663L14.1654 5.83301" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M5.83203 5.83301H14.1654V14.1663" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </button> */}
              {
                address &&
                <button className='p-[30px] block w-full bg-gradient-to-r from-white to-[#32CF0F] group mb-5 mt-10'
                  onClick={Buy_Token}
                  disabled={spinner}
                >
                  {spinner ? "Loading..." : "Buy Now"}

                </button>

              }
              <button className='p-[3px] block w-full bg-gradient-to-r from-white to-[#32CF0F] group mb-5 mt-10'
                onClick={() =>
                  address
                    ? chain?.id == chains[0]?.id
                      ? open()
                      : switchNetwork?.(chains[0]?.id)
                    : open()
                }
              >
                <span className='hover:text-[#04080B] hover:from-[#98FF81] hover:to-[#32CF0F] p-7 bg-gradient-to-r from-[#04080B] to-[#04080B] block font-semibold text-xl'>
                  {address ? (
                    chain?.id == chains[0]?.id ||
                      chain?.id == chains[1]?.id ? (
                      address ? (
                        <>
                          {`${address?.substring(
                            0,
                            6
                          )}...${address?.substring(address.length - 4)}`}
                        </>
                      ) : (
                        <>Connect Wallet</>
                      )
                    ) : (
                      "Switch Network"
                    )
                  ) : (
                    <>Connect Wallet</>
                  )}
                </span>
              </button>
              <span className='block pb-14'>SVO purchases with BTC, SOL, TRX, BNB or XRP? <a href="#" onClick={(e) => { e.preventDefault(); setShowModal(true) }} className='font-semibold underline decoration-white bg-gradient-to-r from-white to-[#32CF0F] bg-clip-text text-transparent whitespace-nowrap'>Click here</a> </span>
            </div>
          </div>
        </div>
      </div>
      <div className={`top-0 left-0 w-full h-full fixed items-center justify-center p-4 text-white ${showModal ? "flex" : "hidden"}`}>
        <div className='bg-[#141E26] w-full max-w-[1200px] relative px-4'>
          <button onClick={() => setShowModal(false)} className='absolute top-6 right-6'>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 6L6 18" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M6 6L18 18" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>
          <div className='w-full max-w-[600px] mx-auto pt-6 pb-16'>
            <h2 className='text-xl font-semibold mb-9'>Buy with other cryptos</h2>
            <form onSubmit={sendEmail}>
              <div className='border border-[#262626] px-6 py-4 flex flex-col gap-4'>
                <label className='text-[#778792] text-xs' htmlFor="user_email">Email *</label>
                <input 
                  name="user_email" 
                  required 
                  placeholder='johndoe123@gmail.com' 
                  className='bg-transparent w-full outline-none' 
                  type="email" 
                  id='user_email' 
                />
              </div>
              <div className='border border-[#262626] px-6 py-4 flex flex-col gap-4'>
                <label className='text-[#778792] text-xs' htmlFor="selected_network">Preferred Network *</label>
                <select 
                  name="selected_network" 
                  required 
                  className='bg-transparent w-full outline-none' 
                  id="selected_network"
                >
                  <option className='text-black' value="">Select network</option>
                  <option className='text-black' value="BTC">BTC</option>
                  <option className='text-black' value="BNB">BNB</option>
                  <option className='text-black' value="SOL">SOL</option>
                  <option className='text-black' value="XRP">XRP</option>
                  <option className='text-black' value="TRX">TRX</option>
                </select>
              </div>
              <div className='border border-[#262626] px-6 py-4 flex flex-col gap-4 mb-12'>
                <label className='text-[#778792] text-xs' htmlFor="user_address">ETH Address to receive SVO</label>
                <input 
                  name="user_address" 
                  required 
                  placeholder='ETH Address to receive SVO' 
                  className='bg-transparent w-full outline-none' 
                  type="text" 
                  id='user_address' 
                />
              </div>
              <button type="submit" className='p-[3px] block w-full bg-gradient-to-r from-white to-[#32CF0F] group mb-5 mt-10'>
                <span className='hover:text-[#04080B] hover:from-[#98FF81] hover:to-[#32CF0F] p-7 bg-gradient-to-r from-[#04080B] to-[#04080B] block font-semibold text-xl'>
                  {spinner ? "Loading..." : "Buy now"}
                </span>
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default App;
